import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { AppResource } from 'src/app/app.resource';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class ErrorComponent extends BaseComponent implements OnInit, OnDestroy {
  title: string = 'ERROR 404';
  message: string = 'Le parcours de souscription auquel vous essayer d\'accéder est indisponible.';

  constructor(resources: AppResource, private route: ActivatedRoute) {
    super(resources);

    // Récupérer les données depuis les data de la route
    const routeData = this.route.snapshot.data;
    if (routeData['title']) {
      this.title = routeData['title'];
    }
    if (routeData['message']) {
      this.message = routeData['message'];
    }

    this.store.updateSizeXL(true);
    this.store.updateBreadcrumb(false);
    this.store.updateVerticalAlign(true);
    this.store.updateHeader(false);
  }

  override ngOnInit() {}

  ngOnDestroy(): void {
    this.store.updateSizeXL(false);
    this.store.updateBreadcrumb(true);
    this.store.updateVerticalAlign(false);
    this.store.updateHeader(true);
  }
}
